/**
 * Maps a vv_shipping_type label (or id) to its SVG asset URL. Labels come
 * from the EAV attribute and may be variations like "Áridos", "Cargas
 * generales", etc. We slugify (lowercase, strip diacritics, spaces→dashes)
 * and match against the bundled assets in src/assets/img/shipping-types.
 *
 * Returns null if no match — caller can fall back to a default icon or the
 * label text.
 */

import aridos from "@/assets/img/shipping-types/aridos.svg";
import cargasEspeciales from "@/assets/img/shipping-types/cargas-especiales.svg";
import cargasGenerales from "@/assets/img/shipping-types/cargas-generales.svg";
import cargasLivianas from "@/assets/img/shipping-types/cargas-livianas.svg";
import hormigon from "@/assets/img/shipping-types/hormigon.svg";
import paqueteria from "@/assets/img/shipping-types/paqueteria.svg";

const ICON_BY_SLUG: Record<string, string> = {
  aridos,
  "cargas-especiales": cargasEspeciales,
  "cargas-generales": cargasGenerales,
  "cargas-livianas": cargasLivianas,
  hormigon,
  paqueteria,
};

const slugify = (input: string): string =>
  input
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

export function getShippingTypeIcon(label?: string | null): string | null {
  if (!label) return null;
  const slug = slugify(label);
  if (ICON_BY_SLUG[slug]) return ICON_BY_SLUG[slug];

  // Common label variations seen in production (defensive aliases).
  const aliases: Record<string, string> = {
    arido: "aridos",
    "carga-general": "cargas-generales",
    "carga-especial": "cargas-especiales",
    "carga-liviana": "cargas-livianas",
    paquete: "paqueteria",
  };
  const aliased = aliases[slug];
  if (aliased && ICON_BY_SLUG[aliased]) return ICON_BY_SLUG[aliased];

  return null;
}

export const SHIPPING_TYPE_DEFAULT_ICON = cargasGenerales;
